import { createPortal } from 'react-dom';
import ModalForm from './ModalForm';
import css from './index.module.scss';
import House from './icons/House';
import BMS from './icons/BMS';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import EFPicture from '@elem/compCommon/EFPicture';
import { Navigation, EffectFade, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef } from 'react';
import { getIsPadWidth } from 'eco-design-micro/utils-base/devices';
import getLocal from 'eco-design-reliance/getLocal';
import EcoLink from 'eco-design/base/eco-link';

export default function P({ freeQuote, freeQuoteBack }: any) {
    const { useLang, useEffect, useState, gtm } = useGlobal();
    const { locale } = getLocal();
    const IS_AU = locale === 'au';
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);
    const [isClient, setIsClient] = useState(false);
    const [selectIndex, setSelectIndex] = useState(0);
    const swiperRef = useRef<any>(null);
    const isMobile = getIsPadWidth(); //是否是移动端

    const items: any[] = [
        {
            icon: <House />,
            title: t('secP_item1_title'),
            desc: t.rich('secP_item1_desc', {
                n: (text: any) => <span className="no-wrap">{text}</span>,
            }),
            tab: t('secP_item1_tab'),
            img: ['https://websiteoss.ecoflow.com/figma-uploads/1784873801591-h10t2j-compressed-Group%20161269633.jpg', ''],
        },
        {
            icon: <BMS />,
            title: t('secP_item2_title'),
            desc: t('secP_item2_desc'),
            tab: t('secP_item2_tab'),
            img: ['https://websiteoss.ecoflow.com/figma-uploads/1784873677979-n5szis-compressed-20231110-105751%202.jpg', ''],
        },
        {
            tab: t('secP_item3_tab'),
            subImages: [
                {
                    img: IS_AU
                        ? [
                              'https://websiteoss.ecoflow.com/figma-uploads/1784873846665-584wpx-compressed-Frame%202094654549.jpg',
                              'https://websiteoss.ecoflow.com/figma-uploads/1784874004848-k712ma-compressed-%E9%80%86%E5%8F%98%E5%99%A803.jpg',
                          ]
                        : [
                              'https://websiteoss.ecoflow.com/upload/image/1773199474819/6-pc-1.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1773199474569/6-m-1.jpg',
                          ],
                    caption: t('secP_item3_img1_caption'),
                },
                {
                    img: IS_AU
                        ? [
                              'https://websiteoss.ecoflow.com/figma-uploads/1784873986183-g6qb0r-compressed-Frame%202094654548.jpg',
                              'https://websiteoss.ecoflow.com/figma-uploads/1784874016526-rizu5w-compressed-%E9%80%86%E5%8F%98%E5%99%A804.jpg',
                          ]
                        : [
                              'https://websiteoss.ecoflow.com/upload/image/1773199475705/6-pc-2.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1773381630654/%E9%80%86%E5%8F%98%E5%99%A804.jpg',
                          ],
                    caption: t('secP_item3_img2_caption'),
                },
                {
                    img: IS_AU
                        ? [
                              'https://websiteoss.ecoflow.com/figma-uploads/1784873993448-7lxpgk-compressed-Frame%202094654547.jpg',
                              'https://websiteoss.ecoflow.com/figma-uploads/1784874023033-c87ft3-compressed-%E9%80%86%E5%8F%98%E5%99%A805.jpg',
                          ]
                        : [
                              'https://websiteoss.ecoflow.com/upload/image/1773199475401/6-pc-3.jpg',
                              'https://websiteoss.ecoflow.com/upload/image/1773381630641/%E9%80%86%E5%8F%98%E5%99%A805.jpg',
                          ],
                    caption: t('secP_item3_img3_caption'),
                },
            ],
        },
    ];

    const handleChangeTab = (k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: items[k].tab,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <section className={`dpu-detail-P dpu-detail-section ${css['dpu-detail-P']}`}>
            <EfSpec />
            {/* <h2 className="title">{t('secP_title')}</h2> */}
            <ul className="items">
                {items?.map((item: any, k: number) => {
                    if (!item?.subImages) {
                        return (
                            <li className={`item ${active === k ? 'active' : ''}`} key={k}>
                                <div className="text-box">
                                    {item?.icon && <div className="item-icon">{item?.icon}</div>}
                                    <div className="item-info">
                                        {item?.title && <h2 className="item-title">{item?.title}</h2>}
                                        {item?.desc && <p className="item-desc">{item?.desc}</p>}
                                    </div>
                                </div>
                                <div className="img-box">
                                    <EFPicture src={`${item?.img[0]}`} srcPad={`${item?.img[1]}`} srcMobile={`${item?.img[1]}`} alt={item?.title} />
                                    {/* {k === 0 && (
                                        <>
                                            <p className="note note1">{t('secP_item1_tip1')}</p>
                                            <p className="note note2">{t('secP_item1_tip2')}</p>
                                            <p className="note note3">{t('secP_item1_tip3')}</p>
                                            <p className="note note4">{t('secP_item1_tip4')}</p>
                                        </>
                                    )} */}
                                </div>
                            </li>
                        );
                    } else {
                        return (
                            <li className={`item sub-image ${active === k ? 'active' : ''} per`} key={k}>
                                {!isMobile &&
                                    item?.subImages.map((sub: any, subK: number) => (
                                        <div className="sub-image-box " key={subK}>
                                            {sub?.caption && <p className={`caption caption-${subK + 1}`}>{sub?.caption}</p>}
                                            <EFPicture src={sub?.img[0]} srcPad={sub.img[1]} srcMobile={sub.img[1]} alt={sub?.caption} />
                                        </div>
                                    ))}
                                {isMobile && (
                                    <Swiper
                                        modules={[EffectFade, Pagination]}
                                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                                        effect={'fade'}
                                        speed={600}
                                        pagination={{ clickable: true }}
                                    >
                                        {item?.subImages.map((sub: any, index: number) => (
                                            <SwiperSlide key={index} className="swiper-slide sub-image-box">
                                                {sub?.caption && <p className={`caption caption-${index + 1}`}>{sub?.caption}</p>}
                                                <EFPicture src={sub?.img[0]} srcPad={sub.img[1]} srcMobile={sub.img[1]} alt={sub?.caption} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                )}
                            </li>
                        );
                    }
                })}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item?.tab}
                    </li>
                ))}
            </ul>
            {isClient && freeQuote && createPortal(<ModalForm callback={() => freeQuoteBack(false)} />, document.body)}
            {!['au'].includes(locale) && <EfSpec />}
        </section>
    );
}
